import PageHeader from "../../../Layout/PageHeader";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useState } from "react";
import Tabs from "../../../Shared/Tab/Tab";
import { bomBasicInformationType } from "./Bom.type";
import FormButton from "../../../Components/Buttons/FormButton";
import pngIcon from "../../../assets/images/xbox.png";
import historyIcon from "../../../assets/images/history-icon.svg";
import { HistoryLaoutBOMMaintenanceDetails } from "../../../Data/testData";
import HistoryLayout from "../../../Layout/HistoryLaout";

export default function BomMaintenanceDetails() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const pageName = `Kitting`;
  const [createbommaintenanceData, setCreatebommaintenanceData] =
    useState<bomBasicInformationType>(new bomBasicInformationType());

  const {
    formState: { errors },
  } = useForm<bomBasicInformationType>({
    defaultValues: createbommaintenanceData,
  });

  const backNavigate = () => {
    return navigate(`/inventory/assembly/kitting/details/${id}`);
  };

  const [isChecked, setIsChecked] = useState(false);

  const tabs = [
    {
      order: 0,
      label: "Basic Information",
      content: (
        <div className="d-flex flex-column h-100">
          <div className="mb-2 mt-1 p-4 h-100 bg-white rounded">
            <div className="p-4 d-flex flex-wrap">
              <div className="col-7">
                <div className="row">
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Code</small>
                    </div>
                    <div className="fs-15">2332</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Description</small>
                    </div>
                    xbox
                  </div>

                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Extended Description</small>
                    </div>
                    <div className="fs-15">Handle With Care</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Category</small>
                    </div>
                    <div className="fs-15">Computers & Electronics </div>
                  </div>

                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Item Group</small>
                    </div>
                    <div className="fs-15">Group A</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Manufacturer</small>
                    </div>
                    <div className="fs-15">Group A</div>
                  </div>

                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">UPC/EAN Code</small>
                    </div>
                    <div className="fs-15">342331</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Sale Price ($)</small>
                    </div>
                    <div className="fs-15">$ 349.99</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Base Cost ($)</small>
                    </div>
                    <div className="fs-15">$ 100.00</div>
                  </div>
                  <div className="mb-5 col-6">
                    <div className="text-secondary ">
                      <small className="fs-14 fw-medium">Average Cost ($)</small>
                    </div>
                    <div className="fs-15">$ 100.00</div>
                  </div>
                </div>
              </div>
              <div className="col-5">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Item Image</small>
                </div>
                <img src={pngIcon} />
              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(`/inventory/assembly/kitting/bom-basic-information-edit/${id}`);
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </div>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Attribute",
      content: (
        <div className="d-flex flex-column h-100">
          <div className="mb-2 mt-1 p-4 h-100 bg-white rounded">
            <div className="p-4 ">
              <div className="row">
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Serial #</small>
                  </div>
                  <div className="form-check form-switch sidebar-toggler mt-auto py-2">
                    <input
                      className="form-check-input toggle-button-size mt-2"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      checked={!isChecked}
                      disabled
                      onChange={() => setIsChecked(!isChecked)}
                    />
                  </div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Tag #</small>
                  </div>
                  <div className="form-check form-switch sidebar-toggler mt-auto py-2">
                    <input
                      className="form-check-input toggle-button-size mt-2"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      checked={!isChecked}
                      disabled
                      onChange={() => setIsChecked(!isChecked)}
                    />
                  </div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Lot #</small>
                  </div>
                  <div className="form-check form-switch sidebar-toggler mt-auto py-2">
                    <input
                      className="form-check-input toggle-button-size mt-2"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      checked={!isChecked}
                      disabled
                      onChange={() => setIsChecked(!isChecked)}
                    />
                  </div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Batch #</small>
                  </div>
                  <div className="fs-15">
                    {" "}
                    <div className="form-check form-switch sidebar-toggler mt-auto py-2">
                      <input
                        className="form-check-input toggle-button-size mt-2"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={!isChecked}
                        disabled
                        onChange={() => setIsChecked(!isChecked)}
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Scannable Item</small>
                  </div>
                  <div className="fs-15">
                    {" "}
                    <div className="form-check form-switch sidebar-toggler mt-auto py-2">
                      <input
                        className="form-check-input toggle-button-size mt-2"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        checked={!isChecked}
                        disabled
                        onChange={() => setIsChecked(!isChecked)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Default Zone</small>
                  </div>
                  <div className="fs-15">Zone 1</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Min Stock Level</small>
                  </div>
                  <div className="fs-15">50</div>
                </div>

                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Max Stock Level</small>
                  </div>
                  <div className="fs-15">100</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Sugg. Stock Level</small>
                  </div>
                  <div className="fs-15">123456</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Item Popularity</small>
                  </div>
                  <div className="fs-15">High Velocity (A)</div>
                </div>
              </div>
              <div className="row">
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">FIFO/LIFO Method</small>
                  </div>
                  <div className="fs-15">FEFO</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Description</small>
                  </div>
                  <div className="fs-15">Date Received</div>
                </div>

                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Country Of Origin</small>
                  </div>
                  <div className="fs-15">US</div>
                </div>
                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Shelf Life</small>
                  </div>
                  <div className="fs-15">60 Days</div>
                </div>

                <div className="mb-5 col">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Ship Life</small>
                  </div>
                  <div className="fs-15">30 Days</div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(
                    `/inventory/assembly/kitting/bom-attribute-edit/${id}`
                  );
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </div>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Configure Kit",
      content: (
        <div className="d-flex flex-column h-100">
          <div className="mb-2 mt-1 p-4 h-100 bg-white rounded">
            <div className=" d-flex flex-wrap">

              <div className="mb-5 col-5 mx-3">
                <div className="text-secondary ">
                  <small className="fs-14 fw-medium">Type of Kit</small>
                </div>
                <div className="fs-15">Kit to stock</div>
              </div>

              <div className="mb-5 col-8">
                <div className="text-secondary ">
                  <div className="p-3">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="text-secondary custom-bom-detail-th-bg">Item Code</th>
                          <th className="text-secondary custom-bom-detail-th-bg">Item Description</th>
                          <th className="text-secondary custom-bom-detail-th-bg">Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>CT1254</td>
                          <td>Chair</td>
                          <td>2</td>
                        </tr>
                        <tr>
                          <td>TB154478</td>
                          <td>Table</td>
                          <td>1</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(`/inventory/assembly/kitting/bom-configure-kit-edit/${id}`);
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </div>


      ),

      visibility: true,
      status: true,
    },
    {
      order: 3,
      label: "User Defined Field",
      content: (
        <>
          <div className="mb-2 mt-1 p-4 bg-white rounded h-100">
            <div className="p-4 ">
              <div className="row">
                <div className="mb-5 col-2 py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 01</small>
                  </div>
                  <div className="fs-15">Lorem lpsum</div>
                </div>
                <div className="mb-5 col-2 py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 02</small>
                  </div>
                  Lorem lpsum
                </div>

                <div className="mb-5 col-6 py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 03</small>
                  </div>
                  <div className="fs-15">Lorem lpsum</div>
                </div>
              </div>
              <div className="row">
                <div className="mb-5 col-8 py-4">
                  <div className="text-secondary ">
                    <small className="fs-14 fw-medium">Custom Field 04</small>
                  </div>
                  <div className="fs-15">Lorem lpsum</div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <FormButton
                tabIndex={11}
                className="sph-btn me-4"
                handleClick={() => {
                  navigate(`/inventory/assembly/kitting/bom-user-defined-field-edit/${id}`);
                }}
              >
                Edit
              </FormButton>
            </div>
          </div>
        </>
      ),

      visibility: true,
      status: true,
    },
  ];
  const [isShowCanvas, setShowCanvas] = useState(false);

  const handelCanvas = () => {
   setShowCanvas(!isShowCanvas);
  };

  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );

  return (
    <div className="col d-flex flex-column">
      <PageHeader
        addUrl="/inventory/assembly/kitting/details/:id"
        listUrl="/inventory/assembly/kitting"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="d-flex flex-column h-100">
        <Tabs
          tabs={tabs}
          isCheckbox={false}
          activeTabClass="d-flex flex-column h-100"
          tabLabelClass="d-flex flex-column h-100"
        />
      </div>

      <HistoryLayout  isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} data={HistoryLaoutBOMMaintenanceDetails} />

    </div>
  );
}
